"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.validateRuleName = exports.matchesCaseInsensitive = void 0;

var _find = _interopRequireDefault(require("lodash/find"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var matchesCaseInsensitive = function matchesCaseInsensitive(a, b) {
  return a.toUpperCase() === b.toUpperCase();
};

exports.matchesCaseInsensitive = matchesCaseInsensitive;

var validateRuleName = function validateRuleName(ruleName, optionConstraints, type) {
  var existingOptionConstraint = (0, _find["default"])(optionConstraints, function (optionConstraint) {
    return matchesCaseInsensitive(optionConstraint.name, ruleName);
  });

  if (existingOptionConstraint) {
    return "There is already an Option Constraint ".concat(type, " with the name ").concat(existingOptionConstraint.name, ".  Names must be unique.");
  }

  return null;
};

exports.validateRuleName = validateRuleName;
var _default = validateRuleName;
exports["default"] = _default;